export enum TTBFraudStatus {
  ALL = 'ALL',
  INITIALIZED = 'INITIALIZED',
  TRIAL_COMING = 'TRIAL_COMING',
  TRIAL_STARTED = 'TRIAL_STARTED',
  TRIAL_HALF_DONE = 'TRIAL_HALF_DONE',
  TRIAL_2_DAYS_LEFT = 'TRIAL_2_DAYS_LEFT',
  TRIAL_1_DAY_LEFT = 'TRIAL_1_DAY_LEFT',
  TIME_TO_DECIDE = 'TIME_TO_DECIDE',
  LAST_CHANCE = 'LAST_CHANCE',
  PRODUCT_RETURNING = 'PRODUCT_RETURNING',
  PRODUCT_PICKED_UP = 'PRODUCT_PICKED_UP',
  PRODUCT_RETURNED = 'PRODUCT_RETURNED',
  PRODUCT_RECEIVED = 'PRODUCT_RECEIVED',
  BOUGHT = 'BOUGHT',
  CANCELLED = 'CANCELLED',
  CHARGED = 'CHARGED',
  MISMATCHED_COMPONENT = 'MISMATCHED_COMPONENT',
  MISMATCHED_COMPONENT_RETURN_PICKED_UP = 'MISMATCHED_COMPONENT_RETURN_PICKED_UP',
  MISMATCHED_COMPONENT_RETURN_RECEIVED = 'MISMATCHED_COMPONENT_RETURN_RECEIVED',
  PRODUCT_RETURNING_TO_TM = 'PRODUCT_RETURNING_TO_TM',
  PRODUCT_RECEIVED_TO_TM = 'PRODUCT_RECEIVED_TO_TM',
  ONE_WEEK_LEFT_TO_FORCED_CHARGE = 'ONE_WEEK_LEFT_TO_FORCED_CHARGE',
  PAUSED = 'PAUSED',
}

export interface selectedNodesType {
  rtId?: string;
  name?: string;
  desc?: string;
  option?: any;
}

export interface cTmCustomconfiguratorNodesType {
  selectedNodes?: selectedNodesType[];
}

export interface ProductInfoType {
  type?: string;
  adjustedTax?: number;
  basePrice?: number;
  bonusProductLineItem?: boolean;
  gift?: boolean;
  itemId?: string;
  itemText?: string;
  price?: number;
  priceAfterItemDiscount?: number;
  priceAfterOrderDiscount?: number;
  productId?: string;
  productName?: string;
  quantity?: number;
  shipmentId?: string;
  tax?: number;
  taxBasis?: number;
  taxClassId?: string;
  taxRate?: number;
  cTmLineItemNo?: number;
  cTmCustomconfiguratorAtoModelName?: string;
  cTmCustomconfiguratorNodes?: cTmCustomconfiguratorNodesType;
}

export interface TTBFraudTableDataType extends TTBFraudType, TTBFraudOtherType {}

export interface TTBFraudType {
  id: string;
  tryThenBuyId?: string;
  userId?: string;
  orderId: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  purchaseIPAddress?: string;
  purchaseIPAddressLocation?: string;
  isSimulator?: boolean;
  isUserBlackList?: boolean;
  fingerPrint?: string;
  purchaseLatitude?: number;
  purchaseLongitude?: number;
  purchaseGPSLocation?: string;
  potentialFraud?: number;
  note?: string;
  cancelReason?: string;
  duplicate?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  productInfo?: ProductInfoType;
  status?: string;
  ttbCreatedAt?: string;
  userCreatedAt?: string;
  signUpIPAddress?: string;
  signUpIPAddressLocation?: string;
  signUpLatitude?: number;
  signUpLongitude?: number;
  signUpGPSLocation?: string;
  userBlackList?: userType;
}

export interface userType {
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  email?: string;
  id?: string;
  updatedAt?: string;
  userId?: string;
}
export interface TTBFraudOtherType {
  index?: number;
  key?: number;
  price?: string;
  productType?: string;
  productId?: string;
  productName?: string;
  productImageUrl?: string;
}

export interface FilterTTBFraudType {
  strSearch?: string;
  status?: string[];
  abnormalOrder?: string | number;
}
export interface SortTTBFraudType {
  sortBy?: string | null;
  sortType?: string | null;
}

export enum TTB_FRAUD_WARNING {
  RED = 'red',
  GREEN = 'green',
  ORG = 'orange',
  ORIGINAL = 'original',
}
